import React from 'react';
import Button, { type ButtonProps } from 'components/control/button';
import styles from './style.module.scss';
import { blurIds } from 'constants/test-constants';
import { ComplianceRequirement } from 'types/compliance';
import { LOCALE_COMMON_PATHS, Namespaces } from 'types/locales';
import { useTranslation } from 'next-i18next';
import { PropsWithDataAttributes } from 'types/react';

type ComplianceOverlayProps = PropsWithDataAttributes<{
  complianceRequirement?: ComplianceRequirement;
  onComplianceRequirementClick?: ButtonProps['onClick'];
}>;

export default function ComplianceOverlay({ complianceRequirement, onComplianceRequirementClick, ...dataAttributes }: ComplianceOverlayProps) {
  const { t } = useTranslation(Namespaces.COMMON);
  if (complianceRequirement === ComplianceRequirement.SIGN_IN) {
    return (
      <div className={styles.component}>
        <p className={styles.disclaimer} data-testid={blurIds.overlaySignInMsg}>
          {t(LOCALE_COMMON_PATHS.LISTING_CARD_COMPLIANCE_OVERLAY_SIGN_IN_MESSAGE,
            { defaultValue: 'Real estate boards require that you sign in to see listing details' })
          }
        </p>
        <Button
          theme="secondary"
          className={styles['cta-button']}
          testId={blurIds.overlaySignInBtn}
          label={t(LOCALE_COMMON_PATHS.BUTTON_SIGN_IN, { defaultValue: 'Sign In' })}
          onClick={onComplianceRequirementClick}
          {...dataAttributes}
          data-compliance-requirement={complianceRequirement}
        />
      </div>
    );
  } else if (complianceRequirement === ComplianceRequirement.TERMS_OF_USE) {
    return (
      <div className={styles.component}>
        <p className={styles.disclaimer} data-testid={blurIds.overlaySignInMsg}>
          {t(LOCALE_COMMON_PATHS.LISTING_CARD_COMPLIANCE_OVERLAY_TERMS_OF_USE_MESSAGE,
            { defaultValue: 'Accept Terms of Use to see listing details' })
          }
        </p>
        <Button
          theme="secondary"
          className={styles['cta-button']}
          testId={blurIds.overlaySignInBtn}
          label={t(LOCALE_COMMON_PATHS.BUTTON_VIEW, { defaultValue: 'View' })}
          onClick={onComplianceRequirementClick}
          {...dataAttributes}
          data-compliance-requirement={complianceRequirement}
        />
      </div>
    );
  }
  return null;
}